.root:hover {
  cursor: pointer;
}